import React, { useState } from 'react';
import { Image, View, TouchableOpacity } from 'react-native';
import * as ImagePicker from 'expo-image-picker';
import { IconButton } from 'react-native-paper';
import { useAppTheme } from '../theme';

export default function MyImagePicker() {
  const [image, setImage] = useState('');
  const theme = useAppTheme();

  const pickImage = async () => {
    // No permissions request is necessary for launching the image library
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.All,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
    });

    console.log(result);

    if (!result.canceled) {
      setImage(result.assets[0].uri);
    }
  };

  return (
    <View style={{ padding: 4 }}>
      {image ? (
        <View>
          <TouchableOpacity onPress={pickImage}>
            <Image
              source={{ uri: image }}
              style={{ height: 150, borderRadius: 4 }}
            />
          </TouchableOpacity>

          <IconButton
            mode="contained"
            size={16}
            icon="close"
            containerColor={theme.colors.primary}
            iconColor="white"
            style={{ position: 'absolute', right: 0 }}
            onPress={() => setImage('')}
          />
        </View>
      ) : (
        <TouchableOpacity
          onPress={pickImage}
          style={{
            height: 150,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#464646',
            borderRadius: 4,
          }}
        >
          <IconButton icon="upload" iconColor="white" size={60} />
        </TouchableOpacity>
      )}
    </View>
  );
}
